import { useQuery } from '@tanstack/react-query';
import { settingsService } from '@/lib/services/settings';
import { resolveImprovementPlanTerm, type ImprovementPlanTerm } from '@/lib/improvementPlanTerm';

/**
 * The store's name for improvement plans (PIP or DAP). Falls back to PIP
 * while settings load, which is also every store's default.
 */
export function useImprovementPlanTerm(): ImprovementPlanTerm {
  const { data: settings } = useQuery({
    queryKey: ['settings'],
    queryFn: settingsService.getSettings,
    staleTime: 5 * 60 * 1000,
  });
  return resolveImprovementPlanTerm(settings);
}
